import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { withRouter, Link, useLocation } from "react-router-dom"
import { getDateString, getOrderPrefix } from "helpers/common_helper"
import { Type } from "react-bootstrap-table2-editor"
import { WindowScrollController } from "@fullcalendar/core"

const columns = (
  toggle,
  handleValidDate,
  handleOrderClick,
  onClickDelete,
  toLowerCase1,
  toggleViewModal,
  designers,
  path
) => {
  const columns = [
    {
      dataField: "Sno",
      text: "S#",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1
      },
    },
    {
      dataField: "orderCode",
      text: "Vector#",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <Link to="#" className="text-body fw-bold">
          {getOrderPrefix(row.requestFor) + row.orderCode}
        </Link>
      ),
    },
    {
      dataField: "orderStatus",
      text: "Vector Status",
      sort: true,
      editor: {
        type: Type.SELECT,
        options: [
          {
            value: "New",
            label: "New",
          },
          {
            value: "Processing",
            label: "Processing",
          },
          {
            value: "Ready",
            label: "Ready",
          },
          {
            value: "Done",
            label: "Done",
          },
        ],
      },
      // eslint-disable-next-line react/display-name
      // formatter: (cellContent, row) => handleValidDate(row.orderdate),
    },
    {
      dataField: "oStatus",
      text: "Vector Status",
      sort: true,
      editor: {
        type: Type.SELECT,
        options: [
          {
            value: "New",
            label: "New",
          },
          {
            value: "Edit",
            label: "Edit",
          },
          {
            value: "Revision",
            label: "Revision",
          },
          {
            value: "Jacket Back",
            label: "JacketBack",
          },
          {
            value: "Lost",
            label: "Lost",
          },
        ],
      },
      // eslint-disable-next-line react/display-name
      // formatter: (cellContent, row) => handleValidDate(row.orderdate),
    },
    {
      dataField: "assTo",
      text: "Ass To",
      sort: true,
      editor: {
        type: Type.SELECT,
        getOptions: setOptions => {
          let rec = []
          designers.docs.map(t => {
            rec.push({
              value: t.userName,
              label: t.userName,
            })
          })
          return rec
        },
      },
    },
    {
      dataField: "assToSalesMan",
      text: "Ass To Sales",
      sort: true,
      editor: {
        type: Type.SELECT,
        getOptions: setOptions => {
          let rec = []
          designers.docs.map(t => {
            rec.push({
              value: t.userName,
              label: t.userName,
            })
          })
          return rec
        },
      },
    },
    {
      dataField: "submitDateTime",
      text: "Received Date",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      formatter: (cellContent, row) => getDateString(row.submitDateTime),
    },
    {
      dataField: "sentDate",
      text: "Sent Date",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      formatter: (cellContent, row) => getDateString(row.submitDateTime),
    },
    {
      dataField: "userName",
      text: "Customer",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
    },
    {
      dataField: "stiches",
      text: "Stiches",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
    },
    {
      dataField: "price",
      text: "price",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
    },

    {
      dataField: "orderName",
      text: "Vector Name",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      editor: {
        type: Type.TEXT,
      },
    },
    {
      dataField: "process",
      text: "Process",
      isDummyField: true,
      sort: false,
      editable: false,
      formatter: (cellContent, order) => (
        <>
          <button
            type="button"
            onClick={toggleViewModal}
            className="btn-sm btn-rounded mb-2 me-2 btn btn-success"
          >
            <i className="mdi mdi-plus me-1"></i> Process
          </button>
        </>
      ),
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Del",
      // Product Name column can't be edit anymore
      editable: false,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, order) => (
        <>
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-danger"
              onClick={() => onClickDelete(order)}
            >
              <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
              <UncontrolledTooltip delay={{ show: 0, hide: 0 }} placement="top" target="deletetooltip">
                Delete
              </UncontrolledTooltip>
            </Link>
          </div>
        </>
      ),
    },
  ]

  let filterdColumns = []

  switch (window.location.pathname) {
    case "/todays-vectors":
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "orderCode" ||
          r.dataField === "orderStatus" ||
          r.dataField === "assTo" ||
          r.dataField === "submitDateTime" ||
          r.dataField === "userName" ||
          r.dataField === "orderName" ||
          r.dataField === "process" ||
          r.dataField === "action"
      )
      break
    case "/ready-vectors":
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "orderCode" ||
          r.dataField === "submitDateTime" ||
          r.dataField === "sentDate" ||
          r.dataField === "userName" ||
          r.dataField === "orderName" ||
          r.dataField === "orderStatus" ||
          r.dataField === "assTo" ||
          r.dataField === "process" ||
          r.dataField === "action"
      )
      break
    case "/all-vectors":
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "oStatus" ||
          r.dataField === "orderCode" ||
          r.dataField === "submitDateTime" ||
          r.dataField === "sentDate" ||
          r.dataField === "userName" ||
          r.dataField === "orderName" ||
          r.dataField === "orderStatus" ||
          r.dataField === "assTo" ||
          r.dataField === "assToSalesMan" ||
          r.dataField === "action"
      )
      break

    case "/vector-with-price-zero":
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "orderCode" ||
          r.dataField === "submitDateTime" ||
          r.dataField === "sentDate" ||
          r.dataField === "userName" ||
          r.dataField === "orderName" ||
          r.dataField === "orderStatus" ||
          r.dataField === "stitches" ||
          r.dataField === "price"
      )
      break
    case "/vector-with-price":
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "orderCode" ||
          r.dataField === "submitDateTime" ||
          r.dataField === "sentDate" ||
          r.dataField === "userName" ||
          r.dataField === "orderName" ||
          r.dataField === "orderStatus" ||
          r.dataField === "price" ||
          r.dataField === "process" 
      )
      break

    default:
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "orderCode" ||
          r.dataField === "oStatus" ||
          r.dataField === "assTo" ||
          r.dataField === "submitDateTime" ||
          r.dataField === "userName" ||
          r.dataField === "orderName" ||
          r.dataField === "process" ||
          r.dataField === "action"
      )
      break
  }

  return filterdColumns
}

columns.propTypes = {
  toggle: PropTypes.func,
  designers: PropTypes.object,
  handleValidDate: PropTypes.func,
  handleOrderClick: PropTypes.func,
  onClickDelete: PropTypes.func,
  locationPath: PropTypes.string,
}

export default columns
